import React, { useContext } from 'react'
import ReactLoading from 'react-loading';
import  ReactDOM  from 'react-dom';
import LoadContext from '../Context/LoadContext';
function Loading() {

  const {loading,setLoading} = useContext(LoadContext)

  if(loading === false) return null
    return ReactDOM.createPortal(
    <div className='loader'>
      <ReactLoading type="spinningBubbles"  height={200} width={200} />
    </div>,document.getElementById("loading")
  )
}

export default Loading
